export const toBoolean = (val) => {
    if(val === "true" || val ==="1" || val === 1 || val===true){
        return true;
    }
    return false;
}